import React from 'react';
import { observable } from 'mobx';
import { ModalPosition, openModal } from 'controls/react/ant/antModal';
import { Observer } from 'mobx-react';
import { Section } from 'controls/react/layout/section';
import { FormEntryNew } from 'controls/react/form/formEntryNew';
import { AntTextArea } from 'controls/react/ant/antInput';
import { translator } from 'core/localization';

const i = translator({
	'Reset health index placeholder': {
		en: 'Type in the reason for resetting healthindex. This will reset health index for all health reasons for this monitor',
		no: 'Skriv inn helseårsak for tilbakestilling av helseindeks. Dette vil resette helse for alle årsåker fra denne monitoren',
	},
	'Reset health index': {
		no: 'Tilbakestill helseindeks',
		en: 'Reset healthindex',
	},
});
export const openResetHealthIndexModal = (
	anchor?: React.MutableRefObject<HTMLElement>,
): [Promise<{ success: boolean; result: string }>, () => void] => {
	const model = observable({ resetReason: '' });

	const { promise, close } = openModal(
		{
			okText: i('Reset'),
			title: i('Reset health index'),
			resizable: false,
			positionType: anchor?.current ? ModalPosition.Anchor : ModalPosition.Mouse,
			positionAnchor: anchor,
		},
		<Observer>
			{() => (
				<Section>
					<FormEntryNew model={model} modelField={'resetReason'}>
						<AntTextArea placeholder={i('Reset health index placeholder')} height={100} />
					</FormEntryNew>
				</Section>
			)}
		</Observer>,
	);
	const result = new Promise<{ success: boolean; result: string }>((resolve) => {
		promise.then((result) => {
			resolve({ result: model.resetReason, success: result ?? false });
		});
	});
	return [result, close];
};
